import { faSearch } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const LookupIcon = ({ toolTipText = "Lookup" }) => (
  <Icon tooltip={toolTipText} iconObj={faSearch} />
);

export default LookupIcon;